import PropTypes from 'prop-types';

import React from 'react';
import { useIntl } from 'react-intl';
import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import { svcMessages } from 'shared/app/messages';

import ManageCardImageLink from '../manage-card-image-link';
import ManageCardLink from '../manage-card-link';
import RefreshBalanceButton from '../refresh-balance-button';
import RefreshBalanceMessage from '../refresh-balance-message';

const SvcCard = ({ card }) => {
  const { balance, cardImageUrl, cardId, nickname } = card;

  const { formatMessage, formatNumber, formats } = useIntl();

  const balanceFormatted = formatNumber(balance.amount, formats.number.money);
  const cardNicknameBalanceFormatted = formatMessage(
    svcMessages.cardNicknameBalance,
    { nickname, balance: balanceFormatted }
  );
  return (
    <div>
      <div className={'flex flex-wrap items-baseline pb3'}>
        <span
          aria-atomic="true"
          aria-live="polite"
          aria-relevant="additions text"
          className="position-relative"
          id="refresh-balance"
        >
          <span className="hiddenVisually">{cardNicknameBalanceFormatted}</span>
          <Heading
            aria-hidden="true"
            data-e2e="cardBalance"
            size="xl"
            tagName="span"
          >
            {balanceFormatted}
          </Heading>

          <RefreshBalanceMessage
            card={card}
            className="position-absolute mt3 ml6"
          />
        </span>

        <RefreshBalanceButton
          aria-controls="refresh-balance"
          card={card}
          className="mx2"
        />

        <span className="ml2 text-right flex-grow">
          <ManageCardLink
            aria-label={formatMessage(svcMessages.cardNicknameManageLink, {
              nickname,
            })}
            cardId={cardId}
          />
        </span>
      </div>

      <ManageCardImageLink
        cardId={cardId}
        cardImageUrl={cardImageUrl}
        cardNickname={nickname}
        imageClassName={'size12of12'}
      />
    </div>
  );
};

SvcCard.propTypes = {
  card: PropTypes.object.isRequired,
};

export default SvcCard;
